import { createStore } from "owa-satcheljs";
import type { ChatAnswer } from "owa-search-copilot-answer-shared";

export interface CopilotSearchAnswerStoreSchema {
    chatAnswer: ChatAnswer | undefined;
    isLoading: boolean;
    currentQuery: string | undefined;
    isScrollMinimized: boolean;
    hasManuallyTriggered: boolean;
}

const initialState: CopilotSearchAnswerStoreSchema = {
    chatAnswer: undefined,
    isLoading: false,
    currentQuery: undefined,
    isScrollMinimized: false,
    hasManuallyTriggered: false,
};

const store: () => CopilotSearchAnswerStoreSchema = createStore<CopilotSearchAnswerStoreSchema>("copilotSearchAnswerStore", initialState);

export default store;
export const getStore: () => CopilotSearchAnswerStoreSchema = store;
